var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fapi-form-alert f-bg-red-100 f-border f-border-red-400 f-text-red-700 f-px-4 f-py-3 f-rounded f-relative",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }